import { createGlobalStyle, css } from "styled-components";
import { PAGE_PRINT_MARGIN, PAGE_PRINT_MARGIN_LARGE } from "report/Constants";
const pdfExportTableStyles = ({ $orientation }) => css`
  .table-data-row .table-data-cell,
  .fields-row.message-group td {
    min-width: ${$orientation === "portrait" ? "50px" : "75px"}!important;
    max-width: ${$orientation === "portrait" ? void 0 : "700px"}!important;
  }
`;
const printMargin = (needsLargeMargin) => needsLargeMargin ? PAGE_PRINT_MARGIN_LARGE : PAGE_PRINT_MARGIN;
const GlobalPDFStyles = createGlobalStyle(
  ({ $orientation, $rootSelector = "html body", $printHeader = false, $printFooter = false }) => css`
    ${$rootSelector} {
      margin-top: 0;
      font-size: 18px;

      ${pdfExportTableStyles({ $orientation })}
    }

    @media print {
      @page {
        margin: ${printMargin($printHeader)} ${PAGE_PRINT_MARGIN} ${printMargin($printFooter)} ${PAGE_PRINT_MARGIN};
      }
    }
  `
);
export default GlobalPDFStyles;
